uniform float uTime;
uniform vec2 uResolution;
uniform float uSize;
uniform sampler2D uParticlesTexture;
uniform float uProgress;

attribute vec2 aParticlesUv;
attribute float aSize;
attribute vec3 aColor;
attribute vec3 aPositionTarget;

varying vec3 vColor;

#include ../includes/simplexNoise4d.glsl

void main()
{
    vec4 particle = texture(uParticlesTexture, aParticlesUv);

    float noiseOrigin = simplexNoise4d(vec4(position * 0.1, 0.0));
    float noiseTarget = simplexNoise4d(vec4(aPositionTarget * 0.1, 0.0));
    float noise = mix(noiseOrigin, noiseTarget, uProgress);
    noise = smoothstep(-1.0, 1.0, noise);

    float duration = 0.3;
    float delay = (1.0 - duration) * noise;
    float end = delay + duration;
    float progress = smoothstep(delay, end, uProgress);
    vec3 mixedPosition = mix(particle.xyz, aPositionTarget, progress);

    vec3 extraNoise = vec3(
            simplexNoise4d(vec4(position * 0.3, uTime * 700.7)),
            simplexNoise4d(vec4(position * 0.3 + vec3(31.0), uTime * 0.7)),
            simplexNoise4d(vec4(position * 0.3 + vec3(17.0), uTime * 0.7))
    );

    vec3 finalPosition = mixedPosition + extraNoise * 0.1;

    // Final position
    // vec4 modelPosition = modelMatrix * vec4(morphedPosition, 1.0);
    // vec4 modelPosition = modelMatrix * vec4(mixedPosition, 1.0);
    vec4 modelPosition = modelMatrix * vec4(finalPosition, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;

    // Point size
    float sizeIn = smoothstep(0.0, 0.1, particle.a);
    float sizeOut = 1.0 - smoothstep(0.7, 1.0, particle.a);
    float size = min(sizeIn, sizeOut);

    gl_PointSize = size * uSize * uResolution.y * aSize;
    gl_PointSize *= (1.0 / - viewPosition.z);

    // Varyings
    // vColor = vec3(1.0);
    vColor = aColor;
}
